import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = {
  key: 0,
  class: "form-group ms-3"
}
const _hoisted_5 = { value: undefined }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center mb-2"
}
const _hoisted_8 = {
  key: 1,
  class: "disabledChatLabel"
}
const _hoisted_9 = { class: "chatMessageContainer" }
const _hoisted_10 = { class: "chatWriter" }
const _hoisted_11 = {
  key: 0,
  class: "quotedMessage"
}
const _hoisted_12 = { class: "sender" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 1,
  class: "chatInput"
}
const _hoisted_15 = {
  key: 0,
  class: "chatInputTop"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "chatInputTop" }
const _hoisted_18 = { class: "chatInputBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_chat_message = _resolveComponent("chat-message")!
  const _component_file_input = _resolveComponent("file-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.chat.identifier && _ctx.isTicket)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Oggetto Ticket:",
                text: "Oggetto Ticket:"
              }),
              _createElementVNode("b", null, _toDisplayString(_ctx.chat.title), 1)
            ]),
            (!_ctx.readonly && _ctx.canEdit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chat.assignedToUser) = $event)),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.assignToUser && _ctx.assignToUser(...args)))
                  }, [
                    _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$localizationService.GetLocalizedValue('Assegna ticket a un utente', 'Assegna ticket a un utente')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descendants, (item, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        value: item.identifier
                      }, _toDisplayString(item.name), 9, _hoisted_6))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.chat.assignedToUser]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        (_ctx.isTicket && !_ctx.readonly && (_ctx.$store.state.isAdmin() || _ctx.$store.state.isDoctor() || _ctx.$store.state.isOperator()))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Stato ticket",
                text: "Stato ticket"
              }),
              _cache[12] || (_cache[12] = _createTextVNode()),
              _createVNode(_component_toggler, {
                class: "ms-2",
                modelValue: _ctx.chat.disabled,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chat.disabled) = $event)),
                  _ctx.chiudiTicket
                ],
                inverse: true
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.chat.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.isTicket ? 'Ticket chiuso' : 'Stanza disabilitata'), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item, i) => {
          return (_openBlock(), _createBlock(_component_chat_message, {
            key: i,
            onDblclick: _withModifiers(($event: any) => (_ctx.onDblClick(item)), ["stop","prevent"]),
            message: item,
            canRemove: _ctx.canEdit,
            onRemoveMessage: _ctx.toggleRemoveMessage,
            "messages-to-remove": _ctx.messagesToRemove
          }, null, 8, ["onDblclick", "message", "canRemove", "onRemoveMessage", "messages-to-remove"]))
        }), 128))
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showNuoviMessaggi)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "newChatMessages",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToBottom && _ctx.goToBottom(...args)))
            }, [
              _createElementVNode("span", null, [
                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-arrow-down" }, null, -1)),
                _cache[14] || (_cache[14] = _createTextVNode()),
                _createVNode(_component_localized_text, {
                  localizedKey: "nuovi messaggi",
                  text: "nuovi messaggi"
                }),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-arrow-down" }, null, -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.quotedMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "cancel",
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelQuote && _ctx.cancelQuote(...args)))
            }, "X"),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.quotedMessage.sender), 1),
            _createElementVNode("span", {
              class: "ellipsis",
              innerHTML: _ctx.quotedMessage.text
            }, null, 8, _hoisted_13)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_ctx.imgPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("img", { src: _ctx.imgPreview }, null, 8, _hoisted_16),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary ms-1",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendImg && _ctx.sendImg(...args)))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Invia",
                      text: "Invia"
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.messageText) = $event)),
                      class: "form-control",
                      onKeypress: _cache[7] || (_cache[7] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.addReturn && _ctx.addReturn(...args)), ["prevent","shift"]), ["enter"])),
                      onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["exact"]), ["enter"]))
                    }, "                        ", 544), [
                      [_vModelText, _ctx.messageText]
                    ]),
                    (_ctx.messagesToRemove.length > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-danger",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeMessages && _ctx.removeMessages(...args)))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Rimuovi messaggi selezionati",
                            text: "Rimuovi messaggi selezionati"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("label", {
                      class: _normalizeClass(["imageUploader btn btn-primary ms-1", { 'disabled': _ctx.fileToUpload }])
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Allega immagine",
                        text: "Allega immagine"
                      }),
                      (_ctx.fileToUpload == null)
                        ? (_openBlock(), _createBlock(_component_file_input, {
                            key: 0,
                            modelValue: _ctx.fileToUpload,
                            "onUpdate:modelValue": [
                              _cache[10] || (_cache[10] = ($event: any) => ((_ctx.fileToUpload) = $event)),
                              _ctx.uploadFile
                            ],
                            class: "d-none"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-primary btn-block", {'disabled': !_ctx.messageText.trim() }]),
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Invia",
                        text: "Invia"
                      })
                    ], 2)
                  ])
                ], 64))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}